import Vue from "vue";
import store from "./store";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7d");

import axios from "axios";
const instance = axios.create({
  baseURL: "https://polymerisapi.iranpolymer.com/api/",
  timeout: 60000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
  }
});

// check user is login and is admin
const requireAdminAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // check user type
    if (user.type === "admin") {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to restricted error page
      next({ name: "Restricted" });
    }
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    instance
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        // check user type
        if (res.data.user.type === "admin") {
          // ok, enjoy it ;)
          next();
        } else {
          // send user to restricted error page
          next({ name: "Restricted" });
        }
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Login" });
      });
  }
};

// check user is login
const requireAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // ok, enjoy it ;)
    next();
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    instance
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then(() => {
        // ok, enjoy it ;)
        next();
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Login" });
      });
  }
};

// disable auth page when user login
const loginedUser = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // redircet to home
    next({ name: "Home" });
  } else {
    const token = Vue.$cookies.get("jwt");
    if (token) {
      instance
        .get("/user/checkToken", {
          headers: {
            Authorization: token
          }
        })
        .then(() => {
          next({ name: "Home" });
        });
    } else {
      next();
    }
  }
};

export { requireAdminAuth, requireAuth, loginedUser };
